import Home from "./Home"
import Experience from "./Experience"
import About from "./About"
import Project from "./Project"
import Services from "./Services"
import Mail from "./Mail"
export default function Mainpage() {
  return (
    <>
    <Home/>
    </>
  )
}
